module.exports = __webpack_public_path__ + "static/media/bg5.86be1391.jpg";